import { render, staticRenderFns } from "./land-lobbi.vue?vue&type=template&id=4963592e"
import script from "./land-lobbi.vue?vue&type=script&lang=js"
export * from "./land-lobbi.vue?vue&type=script&lang=js"
import style0 from "./land-lobbi.vue?vue&type=style&index=0&id=4963592e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports